export const INSURANCE_REFERRAL_FETCH = 'INSURANCE_REFERRAL_FETCH';
export const INSURANCE_REFERRAL_URL_FETCH = 'INSURANCE_REFERRAL_URL_FETCH';
export const INSURANCE_REFERRAL_WITH_QUOTE_FETCH =
  'INSURANCE_REFERRAL_WITH_QUOTE';
export const INSURANCE_UPLOAD_DOCUMENT = 'INSURANCE_UPLOAD_DOCUMENT';
export const INSURANCE_QUOTE_FETCH = 'INSURANCE_QUOTE_FETCH';
export const INSURANCE_CUSTOMER_CONSENT_FETCH =
  'INSURANCE_CUSTOMER_CONSENT_FETCH';
export const INSURANCE_PROFILE_FETCH = 'INSURANCE_PROFILE_FETCH';
export const INSURANCE_PROGRESSIVE_RC1_QUOTE_FETCH =
  'INSURANCE_PROGRESSIVE_RC1_QUOTE_FETCH';
export const INSURANCE_POLICY_FETCH = 'INSURANCE_POLICY_FETCH';
export const SUPPRESS_QUOTE = 'SUPPRESS_QUOTE';
export const UNSUPPORTED_DOCUMENT_SELECTED = 'UNSUPPORTED_DOCUMENT_SELECTED';
export const RESET_UNSUPPORTED_DOCUMENT_SELECTED =
  'RESET_UNSUPPORTED_DOCUMENT_SELECTED';
export const TOGGLE_SHOW_SAMPLE_DOCUMENTS = 'TOGGLE_SHOW_SAMPLE_DOCUMENTS';
export const INSURANCE_VALIDATE_POI = 'INSURANCE_VALIDATE_POI';
